module.exports = __webpack_public_path__ + "static/brand-2a322f778ad8a50d0922aa11e5588ea4.svg";